/*
 * hide / show menu in mobile
 */
(function () {
	document.querySelectorAll('[data-toggle-mainmenu]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			document.getElementById('sidebar').classList.toggle('_opened');
			btn.querySelectorAll('.bi').forEach(function(i) {
				i.classList.toggle('d-none');
			});
		});
	});

	document.getElementById('toggle_sidebar').addEventListener('click', function(event) {
		event.preventDefault();
		if ( !document.body.classList.contains('_reduced') ) {
			document.querySelectorAll('#sidebar .collapse.show').forEach(function(el) {
				el.classList.remove('show');
			});
		}
		/*document.querySelectorAll('#sidebar .collapse').forEach(function(el) {
			el.classList.toggle('collapse-horizontal');
		});*/
		document.body.classList.toggle('_reduced');
	});

	document.querySelectorAll('#sidebar .nav-link[data-bs-toggle="collapse"]').forEach(function(el) {
		el.addEventListener('click', function(event) {
			if ( document.body.classList.contains('_reduced') ) {
				document.body.classList.remove('_reduced');
			}
		});
	});
})();